import { NavLink } from 'react-router-dom-v5-compat'

import { clsx } from 'clsx'

import {
  Heading,
  IdeasIcon,
  Sidebar,
  BookTextIcon,
  NewBadge,
} from '@buffer-mono/popcorn'

import { SidebarFeedNav } from '../../Feed/components/SidebarFeedNav/SidebarFeedNav'

import styles from './ContentSidebar.module.css'

export function ContentSidebar({
  className,
}: {
  className?: string
}): JSX.Element {
  return (
    <Sidebar collapsible="icon" className={clsx(styles.sidebar, className)}>
      <Sidebar.Header data-nohover className={styles.sidebarHeader}>
        <Heading as="h3" size="small" className={styles.contentHeadingTitle}>
          Create
        </Heading>
        <Sidebar.Trigger className={styles.toggleButton} />
      </Sidebar.Header>
      <Sidebar.Content>
        <Sidebar.List>
          <Sidebar.ListItem>
            <Sidebar.Button
              prefix={<IdeasIcon />}
              as={NavLink}
              end
              to="/create"
              size="medium"
              className={styles.ideasNavButton}
            >
              Ideas
            </Sidebar.Button>
          </Sidebar.ListItem>
          <Sidebar.ListItem>
            <Sidebar.Button
              prefix={<BookTextIcon />}
              suffix={<NewBadge size="small" />}
              as={NavLink}
              to="/create/templates"
              size="medium"
            >
              Templates
            </Sidebar.Button>
          </Sidebar.ListItem>
        </Sidebar.List>
        <Sidebar.Separator className={styles.separator} />

        <SidebarFeedNav />
      </Sidebar.Content>
    </Sidebar>
  )
}
